/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import Backbone from 'backbone';
import ViewModel from '@bingads-webui-component-legacy/editorial-appeal/viewmodel/index';
import tmpl from '@bingads-webui-component-legacy/editorial-appeal/template/layout.pug';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/editorial-appeal');
var defaultOptions = {
  i18nKeys: {
    appealInfos: ['EditorialAppeal_AdsItem1', 'EditorialAppeal_AdsItem2'],
    appealTitle: 'EditorialAppeal_AppealTitle'
  },
  rejectedTerms: [],
  rejectedReasons: []
};
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.defaults({}, options, defaultOptions);
    this.i18nKeys = _.defaults({}, this.options.i18nKeys, defaultOptions.i18nKeys);
    this.ko_model = new ViewModel(this.options);
    return this;
  },
  render: function () {
    this.$el.html(tmpl({
      i18n: i18n,
      rejectedTerms: this.ko_model.rejectedTerms(),
      rejectedReasons: this.ko_model.rejectedReasons(),
      i18nKeys: this.i18nKeys
    }));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  setRejectedInfos: function (appealableErrors) {
    this.ko_model.rejectedTerms(appealableErrors.rejectedTerms);
    this.ko_model.rejectedReasons(appealableErrors.rejectedReasons);
  },
  toObject: function () {
    return {
      Appeal: this.ko_model.toObject()
    };
  },
  validate: function () {
    return this.ko_model.provideJustification() ? this.ko_model.validate() : true;
  }
});
export default View;

